import React from 'react';
import { useFormik } from 'formik';
import axios from 'axios';
import './SignIn.css';

let onAuthToken = '';
let baseURL = '';

const initialValues = {
      name: '',
      password: ''
    }

const onSubmit = values => {
  console.log('onSubmit values:', values, baseURL);
    let token_str = "";
    (async () => {
      try {
        const response = await axios({
          method: 'post',
          url: `${baseURL}/api/signin`,
          data: {
            username: values.name,
            password: values.password
          }
        })
        token_str = `Bearer ${response.data.accessToken}`;
        console.log(token_str);
        onAuthToken(token_str);
        } catch(error) {
          console.log(error);
          alert('Invalid credentials. Please try again.');
        }
    })();  
}

const validate = values => {
  // Need errors.name, errors,password
  let errors = {}
  if(!values.name) {
    errors.name = 'User name is required'
  }
  if(!values.password) {
    errors.password = 'Password is required'
  }
  return errors
}

const SignInForm = (props) => {

  onAuthToken = props.onAuth;
  baseURL = props.baseURL;

  const formik = useFormik({ 
    initialValues,
    onSubmit,
    validate
  })

  console.log('Form errors',formik.errors);
   return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div>
          <label htmlFor='name'>User name</label>
          <input 
            type='text'
            placeholder='Enter user name'
            id='name' 
            name='name' 
            onChange={formik.handleChange} 
            onBlur={formik.handleBlur}
            value={formik.values.name} 
          />
          {formik.touched.name && formik.errors.name ? <div className='error'>{formik.errors.name}</div> : null}
        </div>
        <div>
          <label htmlFor='password'>Password</label>
          <input 
            type='password'
            placeholder='Enter password'
            id='password' 
            name='password'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password} 
          />
          {formik.touched.password && formik.errors.password ? <div className='error'>{formik.errors.password}</div> : null}
        </div> 
        <button type='submit' className='btn btn-primary btn-signin'>Sign in</button> 
      </form>
    </div>
  )
}

export default SignInForm;